const requestTestLogsType = 'REQUEST_TEST_Logs';
const receiveTestLogsType = 'RECEIVE_TEST_Logs';
const initialState = { testLogs: [], isLoading: false };

export const actionCreators = {
    requestTestLogs: () => async (dispatch, getState) => {

        if (getState().testLogs.testLogs.length > 0 || getState().isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: requestTestLogsType });

        const url = `api/ATekTestDataApi/GetTestLogs`;
        const response = await fetch(url);
        const testLogs = await response.json();

        dispatch({ type: receiveTestLogsType, testLogs });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestTestLogsType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveTestLogsType) {
        return {
            ...state,
            testLogs: action.testLogs,
            isLoading: false
        };
    }

    return state;
};
